<div
  class="p-container p-3"
  infiniteScroll
  [scrollWindow]="true"
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="150"
  [infiniteScrollDisabled]="isLoading"
  (scrolled)="loadMore()"
>

  <h2 class="font-bold text-2xl">Assessment History List</h2>
 <div class="p-6 ">
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

    <div
      *ngFor="let item of assessmentHistoryList"
      (click)="goToDetails(item)"
      class="group cursor-pointer rounded-3xl border border-card-muted overflow-hidden bg-card dark:border-foreground shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
    >

      <!-- Top Gradient Header (Orange) -->
      <div class="bg-gradient-to-r from-orange-100 to-orange-300 p-4 text-foreground dark:text-black">
        <div class="flex justify-between items-center">
          <h3 class="text-lg font-semibold">Assessment</h3>

          <!-- Status Badge -->
          <span
            class="text-xs px-3 py-1 rounded-full font-medium bg-card/20 backdrop-blur"
          >
            {{ item.status === 1 ? 'Completed' : item.status === 0 ? 'Pending' : 'Failed' }}
          </span>
        </div>
      </div>

      <!-- Card Body -->
      <div class="p-5 bg-card">

        <!-- Icon + Date -->
        <div class="flex items-center gap-4 mb-4">
          <div class="w-12 h-12 flex items-center justify-center rounded-full bg-orange-100 text-orange-600 text-xl">
            🩺
          </div>

          <div>
            <p class="text-sm text-muted-color">Assessment Date</p>
            <p class="font-semibold text-foreground">
              {{ item.created_date | date:'dd MMM yyyy' }}
            </p>
          </div>
        </div>

        <!-- Divider -->
        <div class="border-t my-3"></div>

        <!-- ID -->
        <p class="text-xs text-muted-color break-all">
          Ref ID: {{ item.id }}
        </p>

        <!-- CTA -->
        <div class="mt-4 flex justify-between items-center">
          <span class="text-sm text-gray-500">Tap to view details</span>

          <div
            class="w-8 h-8 flex items-center justify-center rounded-full bg-orange-500 text-white group-hover:bg-orange-600 transition"
          >
            →
          </div>
        </div>

      </div>

    </div>

  </div>

  <!-- Empty State -->
  <div *ngIf="assessmentHistoryList.length === 0 && !isLoading"
       class="text-center mt-16 text-gray-400">
    <p class="text-lg">No assessments found</p>
  </div>

  <!-- Loader -->
  <div *ngIf="isLoading" class="text-center mt-6 text-gray-500">
    Loading...
  </div>
</div>
</div>
